import { useDebounceFn } from '@vueuse/core'

import filterStoresByAssortment from '@/lib/filterStoresByAssortment'
import type { Store } from '@/types'

let currentUsedFilters: string[] = []

interface useDebouncedVisibleMarkersProps {
  map: google.maps.Map | undefined
  markers: google.maps.Marker[] | undefined
  response: { features: Store[] } | undefined
}

const useDebouncedVisibleMarkers = useDebounceFn(
  ({
    map,
    markers,
    response,
  }: useDebouncedVisibleMarkersProps): google.maps.Marker[] | undefined => {
    const currentMapBounds = map?.getBounds() as google.maps.LatLngBounds
    if (!markers) return

    document.addEventListener('assortmentChanged', (event: CustomEventInit) => {
      currentUsedFilters = event.detail
    })

    for (const marker of markers) {
      const markerCoords = {
        lat: marker.getPosition()?.lat(),
        lng: marker.getPosition()?.lng(),
      } as google.maps.LatLngLiteral
      const isMarkerInBounds = currentMapBounds.contains(markerCoords)

      if (isMarkerInBounds) {
        const isMarkerVisible = marker.getVisible()

        const markerMatchesAssortment = filterStoresByAssortment({
          // @ts-ignore
          assortments: marker.assortment,
          filters: currentUsedFilters,
          stores: response?.features,
        })

        if (!isMarkerVisible && markerMatchesAssortment) {
          marker.setVisible(true)
        }
      }
    }

    const filteredMarkers = markers.filter(
      (marker) => marker.getVisible() == true,
    )

    return filteredMarkers
  },
  1000,
)

export default useDebouncedVisibleMarkers
